module.exports = __webpack_public_path__ + "static/media/receipt_loading.a826b954.gif";